module.exports = __webpack_public_path__ + "img/vue1-languette_blanc.308acdca.png";